import React from "react";
import { Modal, Button, Typography, List, Card, Divider } from "antd";
import { FaList, FaRegListAlt } from "react-icons/fa";
import { getMediaTypeIcon } from "../../helpers/mediaTypeIcons";
import {
  useProLanguage,
  PRO_TRANSLATIONS,
} from "../../global/ProLanguageContext";

export default function MediaUsageModalPopup({
  lang: langProp,
  mediaUsage,
  onClose = () => {},
  onConfirmDelete = () => {},
  onGotoPlaylist = () => {},
}) {
  const { lang: langCtx } = useProLanguage();
  const lang = langProp || langCtx;
  const t = (PRO_TRANSLATIONS[lang] || PRO_TRANSLATIONS.en).mediaUsage;

  if (!mediaUsage || mediaUsage.length === 0) return null;

  return (
    <Modal
      title={t.title}
      open={!!mediaUsage}
      onCancel={onClose}
      width={600}
      centered
      footer={[
        <Button key="cancel" onClick={onClose}>
          {t.cancel}
        </Button>,
        <Button key="delete" type="primary" danger onClick={onConfirmDelete}>
          {t.removeAnyway}
        </Button>,
      ]}
    >
      <Typography.Paragraph type="danger">{t.description}</Typography.Paragraph>

      <div style={{ maxHeight: 300, overflowY: "auto", marginBottom: 16 }}>
        {mediaUsage.map((usage, index) => (
          <Card
            key={index}
            style={{ marginBottom: 16, borderRadius: 8, background: "#f9f9f9" }}
          >
            <Typography.Title
              level={5}
              style={{
                marginBottom: 10,
                display: "flex",
                justifyContent: "start",
                alignItems: "center",
                gap: "5px",
              }}
            >
              {usage.FileType.toLocaleLowerCase() == "video"
                ? getMediaTypeIcon("video", 16)
                : getMediaTypeIcon("image", 16)}{" "}
              <span
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: "450px",
                }}
              >
                {usage.FileName}
              </span>
            </Typography.Title>

            <List
              size="small"
              bordered
              dataSource={usage.Playlists}
              renderItem={(playlist) => (
                <List.Item
                  key={playlist.PlaylistID}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: "5px",
                  }}
                >
                  <span
                    style={{
                      display: "flex",
                      justifyContent: "start",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    <FaList /> {playlist.PlaylistName}
                  </span>{" "}
                  <Button
                    size="small"
                    type="dashed"
                    shape="round"
                    onClick={() => {
                      onGotoPlaylist(playlist.PlaylistID);
                    }}
                  >
                    {t.visitPlaylist}
                  </Button>
                </List.Item>
              )}
            />
          </Card>
        ))}
      </div>

      <Divider />
      <Typography.Text type="secondary">{t.footer}</Typography.Text>
    </Modal>
  );
}
